import styled from "styled-components";

export const CertiContainer = styled.div`
  height: 900px;

  //   //justify-content: center;
  //   align-items: center;
  @media screen and (max-width: 768px) {
    height: 400px;
  }
  @media screen and (max-width: 480px) {
    height: 400px;
  }
`;
export const CertiWrapper = styled.div`
  // max-width: 1000px;
  margin: 100px;
  //   display: grid;
  //   grid-template-columns: 1fr 1fr;
  //   align-items: center;
  //   grid-gap: 30px;
  padding: 5px;
  @media screen and (max-width: 1000px) {
    margin: 1px;
  }
  @media screen and (max-width: 768px) {
    margin: 100px 0px 40px;
  }
`;
// export const Img = styled.img`
//   width: 100%;
//   margin: 0 0 60px 120px;
//   padding-right: 20px;
//   border-radius: 50%;
//   height: 420px;
//   width: auto;
//   display: flex;
//   margin-left: 3.5em;
//   @media screen and (max-width: 600px) {
//     height: 190px;
//     margin-left: 3.5em;
//   }
// `;

export const CertiH1 = styled.h1`
  font-size: 2.5rem;
  color: #010606;
  margin-bottom: 64px;
  text-align: center;
  @media screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;
